// Persistent log of alerts that fired, for daily reporting.
const KEY = 'dd-alertlog';

const dayStr = (d = new Date()) => new Date(d).toLocaleDateString('en-CA'); // YYYY-MM-DD

function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } }
function save(log) { localStorage.setItem(KEY, JSON.stringify(log.slice(-3000))); }

// entries: array of { entity, severity, title, icon }
export function logAlerts(entries) {
  if (!entries.length) return;
  const log = get();
  const day = dayStr();
  const now = new Date().toISOString();
  entries.forEach((e) => log.push({ day, t: now, entity: e.entity, severity: e.severity, title: e.title, icon: e.icon, info: e.info, place: e.place || null, vitals: e.vitals || null }));
  save(log);
}

// all alerts logged on a given day (newest first)
export function getDayAlerts(day) {
  return get().filter((e) => e.day === day).sort((a, b) => (b.t || '').localeCompare(a.t || ''));
}

// all alerts whose timestamp falls in [startISO, endISO) — used by the Alarm Report
export function getAlertsBetween(startISO, endISO) {
  return get()
    .filter((e) => e.t && e.t >= startISO && e.t < endISO)
    .sort((a, b) => (a.t || '').localeCompare(b.t || ''));
}

// how many alerts fired on a given day
export const dayAlertCount = (day) => get().filter((e) => e.day === day).length;

export { dayStr };

// count + breakdown of alerts for an entity name on a given day
export function alertsForEntityOnDay(entityName, day) {
  const rows = get().filter((e) => e.day === day && e.entity === entityName);
  const byType = {};
  rows.forEach((r) => { const k = r.title.split('—')[0].trim(); byType[k] = (byType[k] || 0) + 1; });
  return { count: rows.length, byType, rows };
}
